/*
###################################################################
Fitinsur Open Insurance - Copyright 2019-2023 - All Rights Reserved
###################################################################
*/

import React, { useState, useContext, useEffect } from 'react';
import { FitinsurAPI, MessageCenter } from 'utils';
import { GlobalAuthContext } from 'store/context';

function RenderButtons(props) {
  const [isDeclined, setIsDeclined] = useState(false);
  const authContext = useContext(GlobalAuthContext);
  const fitinsur = new FitinsurAPI();
  const mc = new MessageCenter();

  function getOperationInfo() {
    fitinsur.setAuthToken(authContext.token);
    fitinsur.requestOperationInfo(props.idOperation)
      .then(response => response.json())
      .then(response => {
        if(response.idDomainStatus === 2) setIsDeclined(true)  
      })
      .catch((error) => {
        mc.error(`There was an error while fetching your data: ${RenderButtons.name}\n` + error);
      });
  }

  useEffect(() => {
    getOperationInfo()
  }, [])

  return (
    <React.Fragment>
      {!isDeclined && props.children}
    </React.Fragment>
  );
}

export default RenderButtons;